import Link from "next/link";
import { useState, useEffect } from "react";
import { useRouter } from "next/router";
import Image from "next/image";
import Hamburger from "@/atoms/Hamburger";

import { useWindowSize } from "@/shared/hooks/useWindowSize";
import Screen from "@/constants/screens";

import routes from "@/constants/routes";
import { useScrollBlock } from "@/shared/hooks/useScrollBlock";

const HeaderMobile = (): JSX.Element => {
  const { width } = useWindowSize();
  const router = useRouter();
  const [open, setOpen] = useState(false);
  const [blockScroll, allowScroll] = useScrollBlock();

  const [activeDD, setIsActive] = useState("");

  const handleClick = (active: string | undefined) => {
    setIsActive(active === undefined || active === activeDD ? "" : active);
  };

  const toggleMenu = () => {
    setOpen((open) => !open);
  };

  useEffect(() => {
    if (width >= Screen.DESKTOP_1280) {
      setOpen(false);
      allowScroll();
    }

    if (width < Screen.DESKTOP_1280 && open) {
      blockScroll();
    }

    if (width < Screen.DESKTOP_1280 && !open) {
      allowScroll();
    }
  }, [width, open]);

  useEffect(() => {
    if (open) {
      allowScroll();
      setOpen(false);
    }
  }, [router]);

  useEffect(() => {
    // Always restore scrolling on cleanup to avoid leaving the page locked
    return () => allowScroll();
  });

  return (
    <nav
      className={`z-50 w-full overscroll-none overflow-hidden bg-white text-landing-blue h-full`}
    >
      {open ? (
        <div
          className={`w-full relative h-full flex flex-col bg-white overflow-hidden ${
            open ? "block" : ""
          }
            transition duration-300
            ${open ? "opacity-100 z-30 pointer-events-auto" : "opacity-0 -z-1 pointer-events-none"}
            `}
        >
          <div
            className={`relative z-50 flex items-center justify-between w-full md:px-6 px-5 lg:px-11 py-6`}
          >
            <div className="flex items-start justify-start">
              <Link href="/" className="">
                <a className="relative w-32 h-8 xl:w-52 xl:h-12 flex">
                  <Image
                    src={"/shared/keyzy-horizontal-white.svg"}
                    alt="keyzy logo"
                    layout="fill"
                    priority
                  />
                </a>
              </Link>
            </div>

            <Hamburger onClick={toggleMenu} open={open} className="relative z-50 xl:hidden" />
          </div>

          <ul
            className={`flex relative xl:top-auto w-full h-full mb-10 mt-10 overflow-scroll px-5 md:px-20 flex-col text-center pb-[100%]`}
          >
            <li className={`mb-7 md:mb-11`}>
              <Link href={routes.dashboard.root}>
                <a
                  className={`text-lg font-bold ${
                    router.pathname === routes.dashboard.root ? "text-black" : "text-grey-300"
                  }  lg:inline-block lg:mr-10`}
                >
                  Dashboard
                </a>
              </Link>
            </li>
            <li className={`mb-7 md:mb-11`}>
              <Link href={routes.dashboard.documents}>
                <a
                  className={`text-lg font-bold  ${
                    router.pathname === routes.dashboard.documents ? "text-black" : "text-grey-300"
                  } lg:inline-block lg:mx-10`}
                >
                  Documents
                </a>
              </Link>
            </li>
            <li className={`mb-7 md:mb-11`}>
              <Link href={routes.dashboard.howToGuides}>
                <a
                  className={`text-lg font-bold  ${
                    router.pathname === routes.dashboard.howToGuides
                      ? "text-black"
                      : "text-grey-300"
                  } lg:inline-block lg:mx-10`}
                >
                  How to guides
                </a>
              </Link>
            </li>
            <li className={`mb-7 md:mb-11`}>
              <Link href={routes.dashboard.referral}>
                <a
                  className={`text-lg font-bold  ${
                    router.pathname === routes.dashboard.referral ? "text-black" : "text-grey-300"
                  } lg:inline-block lg:mx-10`}
                >
                  Referral
                </a>
              </Link>
            </li>
            <li className={`mb-7 md:mb-11`}>
              <Link href={routes.dashboard.faq}>
                <a
                  className={`text-lg font-bold  ${
                    router.pathname === routes.dashboard.faq ? "text-black" : "text-grey-300"
                  } lg:inline-block lg:mx-10`}
                >
                  FAQs
                </a>
              </Link>
            </li>
            <li className={`mb-7 md:mb-11`}>
              <Link href={routes.dashboard.login}>
                <a className="text-lg font-bold text-black">
                  Your account{" "}
                  <div className="hidden lg:flex lg:ml-3">
                    <Image
                      src="/icons/people.svg"
                      alt="account"
                      width={24}
                      height={24}
                      className="mb-[3px]"
                    />
                  </div>
                </a>
              </Link>
            </li>
          </ul>
        </div>
      ) : (
        <div
          className={`relative z-50 flex items-center justify-between w-full md:px-6 px-5 lg:px-11 py-6`}
        >
          <div className="flex items-start justify-start">
            <Link href="/" className="">
              <a className="relative w-32 h-8 xl:w-52 xl:h-12 flex">
                <Image
                  src={"/shared/keyzy-horizontal-white.svg"}
                  alt="keyzy logo"
                  layout="fill"
                  priority
                />
              </a>
            </Link>
          </div>

          <Hamburger onClick={toggleMenu} open={open} className="relative z-50 xl:hidden" />
        </div>
      )}
    </nav>
  );
};

export default HeaderMobile;
